/*
 * nt-club.js: Growers' Club sign-up (C-3047, T11).
 * Every site sign-up form marked [data-nt-club] joins ONE Klaviyo list ("Growers' Club") through Klaviyo's public
 * client API, tagged with signup_source. Only the store's public site id is used here (no private key; it ships
 * in the page anyway).
 * With no list id configured (theme setting nt_club_list_id blank) this script does nothing and the form posts
 * the native Shopify customer form exactly as before. That is the deliberate fallback, never a silent drop.
 * A failed request is shown to the person and the form stays usable; it never pretends to have worked.
 */
(function () {
  'use strict';
  // T9: members are not asked again. Klaviyo's onsite script knows whether this visitor is an identified profile; if so,
  // every [data-nt-club-members-hide] block (article inline offer and club card) is hidden. Client-side only, nothing
  // is sent anywhere. If Klaviyo never loads, the offer stays visible: the safe direction for a sign-up form.
  if (!window.NTClubMembersWired) {
    window.NTClubMembersWired = true;
    var tries = 0;
    var hideForMembers = function () {
      var k = window.klaviyo;
      if (!k || typeof k.isIdentified !== 'function') {
        if (++tries <= 10) setTimeout(hideForMembers, 500);
        return;
      }
      Promise.resolve(k.isIdentified()).then(function (identified) {
        if (!identified) return;
        var els = document.querySelectorAll('[data-nt-club-members-hide]');
        for (var i = 0; i < els.length; i++) els[i].hidden = true;
      }).catch(function () {});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideForMembers);
    else hideForMembers();
  }

  var cfg = window.NTClub || {};
  if (!cfg.companyId || !cfg.listId) return;
  // The config is rendered beside every sign-up form, so this file can load more than once on a page: wire once.
  if (window.NTClubWired) return;
  window.NTClubWired = true;

  var REVISION = '2024-10-15';
  var BASE = 'https://a.klaviyo.com/client/';

  function post(path, body) {
    return fetch(BASE + path + '?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + path + ' ' + r.status);
      return r;
    });
  }

  function subscribe(email, firstName, source, article) {
    var attrs = { email: email, properties: { signup_source: source } };
    if (article) attrs.properties.signup_article = article;  // T9: which article the sign-up came from
    if (firstName) attrs.first_name = firstName;
    return post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: "Growers' Club: " + source,
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    });
  }

  function saveProperty(email, name, value) {
    var props = {};
    props[name] = value;
    return post('profiles', { data: { type: 'profile', attributes: { email: email, properties: props } } });
  }

  function show(root, step) {
    var steps = root.querySelectorAll('[data-nt-club-step]');
    for (var i = 0; i < steps.length; i++) steps[i].hidden = steps[i].getAttribute('data-nt-club-step') !== step;
    var target = root.querySelector('[data-nt-club-step="' + step + '"]');
    var focus = target && target.querySelector('[data-nt-club-focus]');
    if (focus) focus.focus();
  }

  function setError(form, on) {
    var el = form.querySelector('[data-nt-club-error]');
    if (el) el.hidden = !on;
  }

  function wire(form) {
    var source = form.getAttribute('data-nt-club');
    var root = form.closest('[data-nt-club-root]') || form.parentNode;
    // Shopify's storefront captcha re-submits customer forms natively (form.submit()), which reloads the page over
    // step 2. This form posts to Klaviyo, not Shopify, so opt it out (Shopify's own data-nocaptcha attribute).
    form.setAttribute('data-nocaptcha', 'true');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailEl = form.querySelector('input[type="email"]');
      var nameEl = form.querySelector('input[data-nt-club-first-name]');
      var email = emailEl ? emailEl.value.trim() : '';
      if (!email || (emailEl && !emailEl.checkValidity())) { if (emailEl) emailEl.reportValidity(); return; }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      setError(form, false);
      subscribe(email, nameEl ? nameEl.value.trim() : '', source, form.getAttribute('data-nt-club-article'))
        .then(function () {
          root.setAttribute('data-nt-club-email', email);
          if (root.querySelector('[data-nt-club-step="2"]')) show(root, '2');
          else show(root, 'done');
        })
        .catch(function () {
          setError(form, true);
          if (btn) btn.disabled = false;
        });
    });

    var answers = root.querySelectorAll('[data-nt-club-answer]');
    for (var i = 0; i < answers.length; i++) {
      answers[i].addEventListener('click', function (e) {
        var value = e.currentTarget.getAttribute('data-nt-club-answer');
        var email = root.getAttribute('data-nt-club-email');
        var btns = root.querySelectorAll('[data-nt-club-answer]');
        for (var j = 0; j < btns.length; j++) btns[j].disabled = true;
        saveProperty(email, 'what_matters_most', value)
          .then(function () { show(root, '3'); })
          .catch(function () {
            var err = root.querySelector('[data-nt-club-answer-error]');
            if (err) err.hidden = false;
            for (var k = 0; k < btns.length; k++) btns[k].disabled = false;
          });
      });
    }
    var skip = root.querySelector('[data-nt-club-skip]');
    if (skip) skip.addEventListener('click', function (e) { e.preventDefault(); show(root, '3'); });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-nt-club]');
    for (var i = 0; i < forms.length; i++) wire(forms[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
